import React from "react";
 
const UserIconInCircle = (props:any) => (
<svg

    width="30"

    height="30"

    viewBox="0 0 30 30"

    fill="none"

    {...props}
>

    {/* Outer Circle */}
<circle cx="15" cy="15" r="14" fill="white" stroke="#A60A30" strokeWidth="2" />
 
    {/* User Icon (Centered) */}
<g transform="translate(7.5, 7.5)">
<path

        d="M7.5 0C8.49456 0 9.44839 0.395088 10.1517 1.09835C10.8549 1.80161 11.25 2.75544 11.25 3.75C11.25 4.74456 10.8549 5.69839 10.1517 6.40165C9.44839 7.10491 8.49456 7.5 7.5 7.5C6.50544 7.5 5.55161 7.10491 4.84835 6.40165C4.14509 5.69839 3.75 4.74456 3.75 3.75C3.75 2.75544 4.14509 1.80161 4.84835 1.09835C5.55161 0.395088 6.50544 0 7.5 0ZM7.5 9.375C11.6438 9.375 15 11.0531 15 13.125V15H0V13.125C0 11.0531 3.35625 9.375 7.5 9.375Z"

        fill="#A60A30"

      />
</g>
</svg>

);
 
export default UserIconInCircle;

 